// const dotenv = require("dotenv").config();
const credentials = btoa(`${process.env.REACT_APP_AUTH_USERNAME}:${process.env.REACT_APP_AUTH_PASSWORD}`);

module.exports = {
    test_secret : process.env.TEST_KEY,
    live_secret : process.env.LIVE_KEY,
    baseUrl : process.env.REACT_APP_API_BASE_URL,
    auth_credentials : credentials
}